export default "__VITE_ASSET__DlUtChXu__"